import React from 'react';
import ErrorImage from '../../../../assets/images/no-disponible.png';
import { Container, Button } from './styled';

const NotAccesibleView = ({ goBackButton }: any) => (
  <Container data-testid="event-no-acces-view">
    <div>
      <div className="image-error">
        <img src={ErrorImage} alt="ErrorImage" />
      </div>
      <div className="text">
        <h1 className="title">
          Lo sentimos, este servicio no está disponible.
        </h1>
        <div className="subtitle">
          La actividad ya se realizó, ha sido cancelada o no tiene vacantes.
          Consulta otros servicios.
        </div>
      </div>
    </div>

    <Button
      className="button"
      onClick={goBackButton}
      data-testid="go-back-button"
    >
      Ir a servicios
    </Button>
  </Container>
);

export default NotAccesibleView;
